import React from 'react';
import PropTypes from 'prop-types';

import { Animated } from 'react-native';

import { MOTION } from '../../../constants';
import styles from './calendar.styles';

export default class CalendarSelectedDateGlow extends React.PureComponent {
  static propTypes = {
    visible: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      opacity: new Animated.Value(this.props.visible ? 1 : 0),
    };
  }

  componentWillReceiveProps(nextProps) {
    const visible = nextProps.visible;

    Animated.timing(this.state.opacity, {
      toValue: visible ? 1 : 0,
      duration: MOTION.duration,
      easing: MOTION.easing[visible ? 'in' : 'out'],
    }).start();
  }

  render() {
    return (<Animated.View
      style={[
        styles.selectedDateGlowWrapper,
        { opacity: this.state.opacity },
      ]}
    />);
  }
}
